<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Agregar jarrón</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <div class="upload-img mb-5" v-if="!vase.image">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Subir imagen</vs-button>
        </div>
        <template v-if="vase.image">
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="vase.image" alt="img" class="responsive">
          </div>
          <div class="modify-img mb-4 text-center">
            <vs-button type="flat" color="#999" @click="vase.image=null">Eliminar imagen</vs-button>
          </div>
        </template>

        <vs-input @blur="vase.name = trimString(vase.name)" data-vv-as="nombre" label="Nombre"
                  v-model="vase.name" class="w-full" name="name" v-validate="'required|min:3'"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input data-vv-as="precio" label="Precio (S/)" v-model.number="vase.price"
                  class="mt-5 w-full" name="price" v-validate="'required|min_value:0'"/>
        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import { db, auth, storage, FieldValue } from '@/firebase/firebaseConfig'

export default {
  name: 'NewVase',
  props: {
    isSidebarActive: { type: Boolean, required: true }
  },
  components: { VuePerfectScrollbar },
  mixins: [trimString],
  data () {
    return {
      vase: {},
      settings: { maxScrollbarLength: 60, wheelSpeed: .60 },
      progress: false,
      newImage: null
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) { this.vase = {}; this.newImage = null; this.$validator.reset() }
    },
    vase: {
      handler () { if (this.vase.image === null) this.newImage = null },
      deep: true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () { return this.isSidebarActive },
      set (val) { if (!val) this.$emit('closeSidebar') }
    },
    isFormValid () { return !this.errors.any() },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    async submitData () {
      try {
        let result = await this.$validator.validateAll()
        if (result) {
          this.progress = true
          if (this.newImage != null) this.vase.image = await this.submitImages()
          const obj = {
            ...this.vase,
            price: Number(this.vase.price) || 0,
            state: true,
            uid: auth.currentUser.uid,
            createdAt: FieldValue.serverTimestamp()
          }
          const doc = await db.collection('vases').add({ ...obj })
          obj.id = doc.id
          this.$emit('add', obj)
          this.$emit('closeSidebar')
          this.$vs.notify({ color: 'success', title: 'Jarrón', text: 'Jarrón creado correctamente.' })
        }
      } catch (e) {
        this.$vs.notify({ color: 'warning', title: '¡Oh no!', text: 'Hubo un error.' })
      } finally {
        this.progress = false
      }
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.vase, 'image', e.target.result)
          this.newImage = input.target.files[0]
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    submitImages () {
      return new Promise((resolve, reject) => {
        let imageName = Math.random().toString(36).substr(1, 20)
        let fileExtension = '.' + this.newImage.name.split('.').pop()
        let storageRef = storage.ref(`vases/${imageName}${fileExtension}`)
        storageRef.put(this.newImage)
          .then((snapshot) => { snapshot.ref.getDownloadURL().then((url) => resolve(url)) })
          .catch((error) => reject(error))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background { z-index: 52010; }
  ::v-deep .vs-sidebar { z-index: 52010; width: 400px; max-width: 90vw; }
}
.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  &:not(.ps) { overflow-y: auto; }
}
</style>
